/* ==========================================================================
   Lockett Labs footer behaviour (sections/ll-footer.liquid)

   Small on purpose: it runs on every page.
     - Link columns are accordions on phones only. On larger screens they are
       plain columns that cannot be folded.
     - The watchlist link carries the live count from ll_watchlist, the same key
       and event (ll:watchlist:change) as the rest of the store.
     - The Discord card asks Discord how many people are in the server, once the
       card is near the screen, at most every ten minutes per visit, and shows
       the number only when there is one.
     - The order box opens the tracking page with ?order=N. Only the number goes
       in the URL; the tracking page asks for the email itself.
     - Cookie settings appears only when Shopify's own cookie banner is running,
       and opens its preferences.
     - Back to top.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__llFooterJS) return;
  window.__llFooterJS = true;

  var K_WATCH = 'll_watchlist';
  var K_DISC = 'll_disc_online';
  var DISC_TTL = 10 * 60 * 1000;
  var phoneMQ = window.matchMedia('(max-width: 767.98px)');
  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');

  function readJSON(store, key, fb) {
    try { var v = store.getItem(key); return v ? JSON.parse(v) : fb; } catch (e) { return fb; }
  }
  function writeJSON(store, key, val) {
    try { store.setItem(key, JSON.stringify(val)); } catch (e) {}
  }

  function boot(root) {
    if (!root || root.__llfReady) return;
    root.__llfReady = true;

    /* ---- columns: accordions on phones, fixed open elsewhere ---- */
    var cols = [].slice.call(root.querySelectorAll('[data-llft-col]'));
    function layoutCols() {
      var phone = phoneMQ.matches;
      cols.forEach(function (d) {
        var sum = d.querySelector('summary');
        if (phone) {
          if (!d.__llfTouched) d.open = false;
          if (sum) sum.removeAttribute('tabindex');
        } else {
          d.open = true;
          if (sum) sum.setAttribute('tabindex', '-1');
        }
      });
    }
    cols.forEach(function (d) {
      var sum = d.querySelector('summary');
      if (!sum) return;
      sum.addEventListener('click', function (e) {
        if (!phoneMQ.matches) { e.preventDefault(); return; }
        d.__llfTouched = true;
      });
    });
    layoutCols();
    if (phoneMQ.addEventListener) phoneMQ.addEventListener('change', layoutCols);
    else if (phoneMQ.addListener) phoneMQ.addListener(layoutCols);

    /* ---- watchlist count ---- */
    var watch = root.querySelector('[data-llft-watch]');
    function paintWatch() {
      if (!watch) return;
      var l = readJSON(localStorage, K_WATCH, []);
      var n = Object.prototype.toString.call(l) === '[object Array]' ? l.length : 0;
      watch.hidden = n < 1;
      watch.textContent = n > 99 ? '99+' : String(n);
      watch.setAttribute('aria-label', n === 1 ? '1 item' : n + ' items');
    }
    paintWatch();
    document.addEventListener('ll:watchlist:change', paintWatch);
    window.addEventListener('storage', function (e) { if (!e.key || e.key === K_WATCH) paintWatch(); });

    /* ---- order box ---- */
    var form = root.querySelector('[data-llft-track]');
    if (form) {
      var input = form.querySelector('input[name="order"]');
      var msg = root.querySelector('[data-llft-track-msg]');
      form.addEventListener('submit', function (e) {
        var v = String(input.value || '').replace(/[^0-9A-Za-z]/g, '').slice(0, 24);
        if (!v) {
          e.preventDefault();
          input.setAttribute('aria-invalid', 'true');
          if (msg) msg.textContent = 'Type your order number, for example 2626.';
          input.focus();
          return;
        }
        input.value = v;
      });
      input.addEventListener('input', function () {
        if (input.getAttribute('aria-invalid')) {
          input.removeAttribute('aria-invalid');
          if (msg) msg.textContent = '';
        }
      });
    }

    /* ---- Discord: hidden for anyone who has connected Discord to their watchlist ----
       They are in the server already, so "Join us on Discord" is noise. The band of cards is
       re-counted so the others share the row instead of leaving a gap. */
    var disc = root.querySelector('[data-llft-discord]');
    if (disc) {
      var band = disc.closest('.llft__band');
      var connected = function (st) { return !!(st && st.connected); };
      var setConnected = function (on) {
        if (disc.hidden === on) return;
        disc.hidden = on;
        if (!band) return;
        var n = band.querySelectorAll('.llft__card:not([hidden])').length;
        band.classList.remove('llft__band--1', 'llft__band--2', 'llft__band--3');
        if (n) band.classList.add('llft__band--' + n);
        band.hidden = n === 0;
      };
      var cust = disc.getAttribute('data-customer');
      if (cust) {
        var known = window.__llDiscordState;
        if (!known) {
          /* the identity snippet's own cache, in case its script has not run yet */
          var cached = readJSON(localStorage, 'll_dcx_' + cust, null);
          if (cached && typeof cached.t === 'number' && Date.now() - cached.t < 6 * 60 * 60 * 1000) known = cached.s;
        }
        if (connected(known)) setConnected(true);
        document.addEventListener('ll:discord:state', function (e) { setConnected(connected(e && e.detail)); });
      }
    }
    if (disc && !disc.hidden) {
      var id = disc.getAttribute('data-server');
      var out = disc.querySelector('[data-llft-online]');
      var num = disc.querySelector('[data-llft-online-n]');
      var paint = function (n) {
        if (!out || !num || typeof n !== 'number' || n < 1) return;
        num.textContent = n.toLocaleString('en-GB');
        out.hidden = false;
      };
      var load = function () {
        var c = readJSON(sessionStorage, K_DISC, null);
        if (c && c.id === id && Date.now() - c.t < DISC_TTL) { paint(c.n); return; }
        if (!window.fetch) return;
        fetch('https://discord.com/api/guilds/' + encodeURIComponent(id) + '/widget.json')
          .then(function (r) { if (!r.ok) throw new Error('widget off'); return r.json(); })
          .then(function (d) {
            var n = d && typeof d.presence_count === 'number' ? d.presence_count : 0;
            writeJSON(sessionStorage, K_DISC, { id: id, n: n, t: Date.now() });
            paint(n);
          })
          .catch(function () {});
      };
      if (id && /^\d{5,25}$/.test(id)) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); load(); }
          }, { rootMargin: '400px 0px' });
          io.observe(disc);
        } else {
          load();
        }
      }
    }

    /* ---- cookie settings: only with Shopify's banner, which loads late ---- */
    var cookieBtn = root.querySelector('[data-llft-cookies]');
    var cookieLi = root.querySelector('[data-llft-cookies-li]');
    function bannerReady() {
      return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
    }
    if (cookieBtn && cookieLi) {
      var tries = 0;
      (function check() {
        if (bannerReady()) { cookieLi.hidden = false; return; }
        if (++tries < 20) setTimeout(check, 750);
      })();
      cookieBtn.addEventListener('click', function () {
        if (bannerReady()) window.privacyBanner.showPreferences();
      });
    }

    /* ---- back to top: scroll, then put focus somewhere sensible at the top ---- */
    var top = root.querySelector('[data-llft-top]');
    if (top) {
      top.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: reduceMQ.matches ? 'auto' : 'smooth' });
        var first = document.querySelector('header.site-header a[href], header a[href]');
        if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
      });
    }

    /* ---- Follow on Shop draws its label inside a shadow root; keep it legible on plum ---- */
    var follow = root.querySelector('.llft__follow');
    if (follow) {
      var fix = function () {
        [].forEach.call(follow.querySelectorAll('*'), function (el) {
          if (el.shadowRoot && !el.shadowRoot.__llf) {
            var st = document.createElement('style');
            st.textContent = '* { color: #ffffff !important; }';
            el.shadowRoot.appendChild(st);
            el.shadowRoot.__llf = true;
          }
        });
      };
      fix();
      setTimeout(fix, 1500);
    }
  }

  function bootAll() {
    [].forEach.call(document.querySelectorAll('[data-llft]'), boot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
  else bootAll();

  /* Theme editor: a re-rendered section is a new element that needs booting. */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-llft]');
    if (el) boot(el);
  });
})();
